import { jsx as _jsx } from "react/jsx-runtime";
import { CardActions as MuiCardActions, } from '@mui/material';
import { styled } from '../../../utils';
export function CardActions(props) {
    const { noPadding = false, ...otherProps } = props;
    return _jsx(CardActionStyled, { noPadding: noPadding, ...otherProps });
}
const CardActionStyled = styled(MuiCardActions, {
    shouldForwardProp: (prop) => prop !== 'justify' && prop !== 'noPadding',
})(({ theme, justify, noPadding }) => ({
    marginTop: 'auto',
    padding: theme.spacing(1, 2, 2),
    gap: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(1, 2.5, 2.5),
    },
    '&:first-of-type': {
        paddingTop: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            paddingTop: theme.spacing(2.5),
        },
    },
    ...(noPadding && {
        paddingTop: 0,
    }),
    ...(justify && { justifyContent: justify }),
}));
